export default "__VITE_ASSET__7d6ab587__"